export default __webpack_public_path__ + "static/Frame355-c7d84b9ccb6dafb78f1865a98cb2e485.png";